import React from "react";
import { connect } from "react-redux";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface extends RouteComponentProps {
  location: any;
  Store: any;
  Dispatch: any;
  text: string;
  link?: any;
  index: number;
}

interface StateInterface {
  showTime: number;
  index: number;
}

class Default extends React.Component<PropsInterface, StateInterface> {
  constructor(Props: PropsInterface) {
    super(Props);
    this.state = {
      showTime: 5 * 1000, // 5 sec
      index: this.props.index,
    };

    this.destroyAlert = this.destroyAlert.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.destroyAlert();
    }, this.state.showTime);
  }

  destroyAlert() {
    setTimeout(() => {
      this.props.Dispatch(Middleware.Ui.Alert.close(this.state.index));
    }, 100);
  }

  public render() {
    return (
      <>
        <div className="alert">
          <div className="text">{this.props.text}</div>
          {this.props.link !== undefined ? (
            <Link to={this.props.link?.url} className="link">
              {this.props.link?.name}
            </Link>
          ) : (
            <></>
          )}
          <div className="close" onClick={this.destroyAlert}>
            <i className="icon-cross" />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
